export default __webpack_public_path__ + "static/media/Logo quoc Loc Phat-02.dc8a8151.png";